require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicalnewstoday-definition.json") })
        }
      }, "path---article-medicalnewstoday-definition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicalnewstoday-definition!./.cache/json/article-medicalnewstoday-definition.json
// module id = 349
// module chunks = 231608221292675